/**
 * Module-scoped accessor for the i18n translate function.
 *
 * This decouples `useTranslate()` from requiring a Vue component setup context,
 * allowing it to work in Pinia stores, composables, and other non-component contexts.
 *
 * The translate function is resolved lazily:
 * - Nuxt app: captured from `useNuxtApp().$i18n` on first `useTranslate()` call
 * - Storybook: set explicitly via `setTranslateFn()` in preview.ts
 */

type TranslateFn = (key: string, args?: Record<string, unknown>) => string

let _translate: TranslateFn | null = null

export function setTranslateFn(fn: TranslateFn) {
  _translate = fn
}

export function getTranslateFnOrNull(): TranslateFn | null {
  return _translate
}
